import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, animate, useMotionValue } from "framer-motion";
import "./HomePage.css";
// import customcursor from "../components/CustomCursor
import CustomCursor from '../components/CustomCursor';
import useMeasure from "react-use-measure";

function HomePage() {
  const images = [
    "/images/image1.png",
    "/images/image2.png",
    "/images/image3.png",
    "/images/image16.PNG",
    "/images/image9.png",
    "/images/image4.jpeg",
    "/images/image5.jpeg",
    "/images/image6.jpeg",
    "/images/image7.png",
    "/images/image10.jpeg",
    "/images/image11.jpeg",
    "/images/image12.jpeg",
    "/images/image13.jpeg",
    "/images/image14.png",
    "/images/image15.PNG",

    "/project_images_compressed/art/city-unwrapped/scan1.jpg",
    "/project_images_compressed/art/sand-remembers/thesis2.jpg",
  ];
  
  const FAST_DURATION = 35; // Faster scroll duration in seconds
  const SLOW_DURATION = 50; // Faster scrolling when hovering
  
  const yTranslation = useMotionValue(0);
  const [duration, setDuration] = useState(FAST_DURATION);
  const [mustFinish, setMustFinish] = useState(false);
  const [rerender, setRerender] = useState(false);

//   const marginHeight = 10;// Adjust this value based on your image height
    const [ref, { height}] = useMeasure();

  useEffect(() => {
    const finalPosition = -(height)/2; // Scroll to the total combined height of images

    let controls;
    if (mustFinish) {
      controls = animate(yTranslation, [yTranslation.get(), finalPosition], {
        ease: "linear",
        duration: duration * (1 - yTranslation.get() / finalPosition),
        onComplete: () => {
          setMustFinish(false);
          setRerender(!rerender); // Trigger re-render
        },
      });
    } else {
      controls = animate(yTranslation, [0, finalPosition], {
        ease: "linear",
        duration: duration,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 0,
      });
    }

    return controls?.stop;
  }, [ yTranslation, duration, mustFinish, rerender, height, images.length]); // Add rerender to dependencies

  return (
    <div className="home-container">
      <CustomCursor />
      <div className="content">
        <h1>will hardison</h1>
        <ul className="project-list">
          <li><Link to="/code">code</Link></li>
          <li><Link to="/art">art</Link></li>
          <li><Link to="/design">design</Link></li>
          <li><Link to="/animation">animation</Link></li>
          <li><Link className="interactive-link" to="/interactive">interactive</Link></li>
        </ul>
      </div>
      <div className="image-scroll">
        <motion.div
          ref={ref}
          className="scroll-container"
          style={{ y: yTranslation }}
          onHoverStart={() => {
            setMustFinish(true);
            setDuration(SLOW_DURATION);
          }}
          onHoverEnd={() => {
            setMustFinish(true);
            setDuration(FAST_DURATION);
          }}
        >
          {[...images, ...images].map((img, index) => (
            <img key={index} src={img} alt="" />
          ))}
        </motion.div>
      </div>
    </div>
  );
}

export default HomePage;
